if (!window.__goalFilterInit) {
  window.__goalFilterInit = true;

  document.addEventListener('click', (event) => {
    const pill = event.target.closest('[data-goal-filter]');
    if (!pill) return;

    const tag = pill.dataset.goalFilter;
    const group = pill.closest('[data-goal-picker]');

    if (group) {
      Array.from(group.querySelectorAll('.is-active')).forEach((el) => el.classList.remove('is-active'));
      pill.classList.add('is-active');
    }

    // Empty tag = the "All" link — clears any filtering.
    document.querySelectorAll('[data-product-tags]').forEach((card) => {
      const cardTags = (card.dataset.productTags || '').toLowerCase().split(',');
      const matches = tag === '' || cardTags.includes(tag.toLowerCase());
      card.classList.toggle('goal-picker__card--filtered-out', !matches);
    });
  });
}
